var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l1 = _vm.__map(_vm.dataList, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var l0 = item.detailList
      ? _vm.__map(item.detailList, function (goods, __i1__) {
          var $orig = _vm.__get_orig(goods)
          var g0 = ((goods.subtotal || 0) / 100).toFixed(2)
          return {
            $orig: $orig,
            g0: g0,
          }
        })
      : null
    var g1 = ((item.estimatedAmount || 0) / 100).toFixed(2)
    var g2 = ((item.declaredFee || 0) / 100).toFixed(2)
    return {
      $orig: $orig,
      l0: l0,
      g1: g1,
      g2: g2,
    }
  })
  var g3 = !_vm.isLoadingMore ? !_vm.hasNext && _vm.dataList.length : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event, item) {
      var _temp = arguments[arguments.length - 1].currentTarget.dataset,
        _temp2 = _temp.eventParams || _temp["event-params"],
        item = _temp2.item
      var _temp, _temp2
      _vm.activeTab = item.value
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l1: l1,
        g3: g3,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }